import React from "react";
import { makeStyles } from '@mui/styles';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { cancel } from "./api-progress-log";
import { useSelector, useDispatch } from "react-redux";
import { setProgressLog } from "./actions/actions";
import Button from "../../../components/UI/Button";
import LinearProgress from "../../../components/UI/LinearProgress";
import Box from "../../../components/UI/Box";

const useStyles = makeStyles(() => ({
    paper: {
        padding: '20px'
    },
    messagesBox: {
        padding: '20px',
        border: 'solid 1px',
        marginLeft: '10px',
        marginRight: '10px',
        marginTop: '20px',
        borderRadius: '25px'
    }
}));

export default function ProgressLogForm() {
    const classes = useStyles();
    const progressLog = useSelector(state => state.progressLog);
    const dispatch = useDispatch();

    const handleCancel = () => {
        cancel(progressLog);
        dispatch(setProgressLog(null));
    }

    return (
        <div>
            <Container className={classes.paper} component={Paper} >
                <Typography className={classes.title} variant="h5">
                    Progresso
                </Typography>
                <Box display="flex" alignItems="center">
                    <Box width="100%" mr={1}>
                        <LinearProgress variant="determinate" value={progressLog.porcentagem} />
                    </Box>
                    <Box minWidth={35}>
                        <Typography variant="body2" color="textSecondary">{`${Math.round(
                            progressLog.porcentagem,
                        )}%`}</Typography>
                    </Box>
                </Box>
                <Button
                    variant="contained"
                    onClick={handleCancel}
                    color="secondary"
                    className={classes.submit}>
                    Cancelar
                </Button>
                <div className={classes.messagesBox} >
                    <Typography style={{ whiteSpace: 'pre-line' }}>
                        {progressLog.mensagem}
                    </Typography>
                </div>


            </Container>
        </div>
    );

}